<template>
  <div class="order page-container bg-white">
    <div class="pageHead-wrapper">
      <PageHeader title="订单记录">
        <template slot="icon">
          <img :src="pageIcon" width="16px" height="16px" alt="">
        </template>
      </PageHeader>
    </div>
    <!-- 表单查询 -->
    <div class="search-panel">
      <Json2Form
        :form="form"
        :fieldsSource="fieldsSource"
        :options="options"
        :btns="btns"
        formClass="json2form"
        @submit="handleSubmit"
        ref="search-form"
      >
        <template slot="line_code" slot-scope="form, item">
          <a-tree-select
            v-model="form[item.name]"
            tree-default-expand-all
            :tree-data="treeData"
            :maxTagCount="2"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            :replaceFields="{
              children: 'sub_line',
              title: 'name',
              key: 'code',
              value: 'code',
            }"
            placeholder="请选择"
            :allowClear='true'
          />
        </template>
      </Json2Form>
    </div>
    <!-- 列表 -->
    <div class="content">
      <div>
        <a-space size="middle" style="margin-bottom: 20px;">
          <span>已选中 <span class="textBlue">{{ selectedRowKeys.length }}</span> 条</span>
          <a-button
            type="default"
            class="customBtn"
            @click="sendOrders('add')"
            :disabled="btnDisabled"
          >
            批量发货
          </a-button>
          <a-button
            type="default"
            class="customBtn"
            @click="sendOrders('edit')"
            :disabled="btnDisabled"
          >
            批量修改
          </a-button>
        </a-space>
        <a-button
          type="primary"
          class="greenBtn"
          @click="handleExport"
          style="float: right"
        >
          导出
        </a-button>
      </div>

      <a-table
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :columns="columns"
        :data-source="tableData"
        :scroll="{ x: 2600 }"
        :pagination="ipagination"
        @change="handleTableChange"
        :loading="tableLoading"
        rowKey="uuid"
      >
        <template slot="goods_info" slot-scope="text, record">
          <div :title="record.goods_name" class="ellipsis" style="width: 260px;">{{ record.goods_name }}</div>
          <div :title="record.goods_uuid" class="ellipsis" style="width: 260px;">{{ record.goods_uuid }}</div>
          <div :title="record.goods_attr" class="ellipsis" style="width: 260px;">
            {{ (record.goods_attr || []).join(',') }}
          </div>
        </template>
        <template slot="address_info" slot-scope="text, record">
          <div :title="record.contact_user" class="ellipsis" style="width: 280px;">{{ record.contact_user }}</div>
          <div :title="record.contact_tel" class="ellipsis" style="width: 280px;">{{ record.contact_tel }}</div>
          <div :title="record.contact_address" class="ellipsis" style="width: 280px;">{{ record.contact_address }}</div>
        </template>
        <template slot="status" slot-scope="text, record">
          <State :text="record.status_name" :status="record.status_className" />
        </template>
        <template slot="action" slot-scope="text, record">
          <a-space>
            <a-button
              v-if="record.status === 'waiting'" type="link"
              @click="showDetailModel(record, 'send')"
            >发货</a-button>
            <a-button
              v-if="record.status === 'waiting' || record.status === 'processing'"
              type="link"
              @click="showDetailModel(record, 'cancel')"
            >取消订单</a-button>
            <a-button
              v-if="record.status === 'delivered'"
              type="link"
              @click="showDetailModel(record, 'revise')"
            >修改</a-button>
            <a-button
              v-if="record.status === 'cancelled' || record.status === 'fail'"
              type="link"
              @click="showDetailModel(record, 'look')"
            >查看</a-button>
          </a-space>
        </template>
      </a-table>
    </div>
    <!-- 批量修改/发货 -->
    <a-modal
      v-model="sendModelVisible"
      :title="sendModelTitle"
      :destroyOnClose="true"
      @ok="sendModelConfirm"
      :width="500"
      :maskClosable="false"
      dialogClass="commonModal"
      :confirm-loading="confirmLoading"
    >
      <div style="margin-bottom: 20px;">
        本次将对 <span class="textGreen">{{ selectedRowKeys.length }}</span> 条记录进行{{ sendModelTitle }}操作
      </div>
      <a-form :form="sendModelForm" :layout="formLayout" @submit="getListData">
        <a-form-item v-bind="{}" label="快递单号">
          <a-input
            v-decorator="[
              'express_number',{
                rules: [],
              },
            ]"
            placeholder="请输入内容"
          />
        </a-form-item>
        <a-form-item v-bind="{}" label="备注">
          <a-input
            type="textarea"
            placeholder="请输入备注"
            v-decorator="[
              'comment',
              {
                rules: [],
              },
            ]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
    <!-- 发货/取消订单/查看弹出框 -->
    <a-modal
      v-model="detailModelVisible"
      :title="detailModelTitle"
      :destroyOnClose="true"
      @ok="detailModelConfirm"
      :width="500"
      :maskClosable="false"
      :footer="showModelFooter"
      dialogClass="commonModal detailModal"
      ref="detailModel"
      :confirm-loading="confirmLoading"
    >
       <a-form
        :form="detailModelForm"
        layout="horizontal"
        labelAlign="left"
      >
         <a-form-item v-bind="formItemLayout" label="订单号">
          <span class="ant-form-text">{{ record.uuid }}</span>
        </a-form-item>
        <a-form-item v-bind="formItemLayout" label="用户id">
          <span class="ant-form-text">{{ record.creator_uid }}</span>
        </a-form-item>
        <a-form-item v-bind="formItemLayout" label="用户姓名">
          <span class="ant-form-text">{{ record.creator }}</span>
        </a-form-item>
        <a-divider />
        <a-form-item v-bind="formItemLayout" label="下单时间">
          <span class="ant-form-text">{{ record.create_time }}</span>
        </a-form-item>
        <a-form-item v-bind="formItemLayout" label="商品id">
          <span class="ant-form-text">{{ record.goods_uuid }}</span>
        </a-form-item>
        <a-form-item v-bind="formItemLayout" label="商品名称">
          <span class="ant-form-text">{{ record.goods_name }}</span>
        </a-form-item>
        <a-form-item v-bind="formItemLayout" label="规格">
          <span class="ant-form-text">{{ (record.goods_attr || []).join(',') }}</span>
        </a-form-item>
        <a-form-item v-bind="formItemLayout" label="数量">
          <span class="ant-form-text">{{ record.count }}</span>
        </a-form-item>
        <a-divider />
        <a-form-item v-bind="formItemLayout" label="联系信息">
          <div class="ant-form-text">
            {{ record.contact_user }} {{ record.contact_tel }}<br>
            {{ record.contact_address }}
          </div>
          <span class="ant-form-text">{{ record.address }}</span>
        </a-form-item>
        <a-form-item v-bind="formItemLayout" label="用户备注">
          <span class="ant-form-text">{{ record.user_comment }}</span>
        </a-form-item>
        <!-- 查看 -->
        <a-form-item v-if="detailModelType === 'look'" v-bind="formItemLayout" label="备注">
          <span class="ant-form-text">{{ record.comment }}</span>
        </a-form-item>
        <!-- 发货/修改 -->
        <div v-if="detailModelType === 'send' || detailModelType === 'revise'">
          <a-form-item v-bind="formItemLayout" label="快递单号">
            <a-input
              v-decorator="[
                'express_number',
                {
                  rules: [],
                },
              ]"
              placeholder="请输入内容"
            />
          </a-form-item>
          <a-form-item v-bind="formItemLayout" label="备注">
            <a-input
              type="textarea"
              placeholder="请输入备注"
              v-decorator="[
                'comment', {
                  rules: [],
                },
              ]"
            />
          </a-form-item>
        </div>
        <!-- 取消订单 -->
        <a-form-item v-if="detailModelType === 'cancel'" v-bind="formItemLayout" label="备注">
          <a-input
              type="textarea"
              placeholder="请输入备注"
              v-decorator="[
                'comment',
                {
                  rules: [
                    {
                      required: true,
                      message: '请输入备注',
                    },
                  ],
                },
              ]"
            />
        </a-form-item>
       </a-form>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment';
import Json2Form from '@/components/Json2Form';
import PageHeader from '@/components/PageHeader/customPageHeader';
import State from '@/components/State/status.vue';
import { FIELD_SOURCE, COLUMNS, STATUS_EUNM } from './constants/';
import { getBaseInfo } from '@/api/address/';
import { getOrderList, orderEdit } from '@/api/order/';
import { formatOptionsData, formatTreeData } from '@/utils/formatData/';
import { paginationItem } from '@/constants/goods/';

const modalTitleMap = {
  look: {
    title: '查看',
    nextStatus: '',
  },
  send: {
    title: '发货',
    nextStatus: 'delivered',
  },
  revise: {
    title: '修改',
    nextStatus: 'delivered',
  },
  cancel: {
    title: '取消订单',
    nextStatus: 'cancelled',
  },
};

export default {
  name: 'TableList',
  components: {
    Json2Form,
    PageHeader,
    State,
  },
  data() {
    return {
      form: {},
      treeData: [],
      record: {},
      formLayout: 'vertical',
      tableData: [],
      selectedRows: [],
      selectedRowKeys: [],
      searchFormData: {}, // 查询表单参数
      columns: COLUMNS,
      fieldsSource: FIELD_SOURCE,
      tableLoading: false,
      deleteVisible: false,
      sendModelTitle: '',
      sendModelVisible: false, // 批量发货弹框
      detailModelVisible: false, // 发货/查看等弹框
      detailModelTitle: '', // 弹框标题
      showModelFooter: undefined, // 是否显示底部按钮
      confirmLoading: false,
      detailModelType: '',
      btnDisabled: false,
      pageIcon: require('@/assets/img/order.png'),
      ipagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        ...paginationItem,
      },
      btns: [
        {
          action: 'submit',
          text: '查询',
          style: {
            color: '#fff',
            background: '#345FEC',
            border: 'none',
          },
        },
        {
          action: 'reset',
          text: '重置',
          force: true,
        },
      ],
      options: {
        layout: 'inline',
        gutter: 12,
        labelCol: {
          xl: {
            span: 8,
          },
          xxl: {
            span: 6,
          },
        },
        wrapperCol: {
          xl: {
            span: 16,
          },
          xxl: {
            span: 18,
          },
        },
      },
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
      },
    };
  },
  beforeCreate() {
    this.sendModelForm = this.$form.createForm(this, { name: 'send' });
    this.detailModelForm = this.$form.createForm(this, { name: 'detail' });
  },
  mounted() {
    this.getBaseInfo();
    this.handleSubmit();
  },
  methods: {
    // 显示发货弹框
    showDetailModel(record, type) {
      this.record = record;
      this.detailModelType = type;
      this.detailModelTitle = modalTitleMap[type].title;
      type === 'look'
        ? this.showModelFooter = null
        : this.showModelFooter = undefined;
      this.detailModelVisible = true;
      if (type === 'send' || type === 'revise') {
        this.$nextTick(() => {
          this.detailModelForm.setFieldsValue({
            express_number: this.record.express_number,
            comment: this.record.comment,
          });
        });
      }
    },
    // 列表复选框改变
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRows = selectedRows;
      this.selectedRowKeys = selectedRowKeys;
      if (this.selectedRows.length > 1) {
        const { supplier_name: supplierName, contact_address: contactAddress,
          contact_user: contactUser, contact_tel: contactTel } =  this.selectedRows[0];
        this.btnDisabled = !this.selectedRows.every((v) => (
          v.supplier.name === supplierName
          && v.contact_address === contactAddress
          && v.contact_user === contactUser
          && v.contact_tel === contactTel
        ));
      } else {
        this.btnDisabled = false;
      }
    },
    // 批量发货/修改
    sendOrders(type) {
      type === 'edit' ? this.sendModelTitle = '批量修改' : this.sendModelTitle = '批量发货';
      // 判断选中
      if (this.selectedRowKeys.length === 0) {
        this.$message.warning('请选择订单！');
        return;
      }
      // 判断订单状态
      try {
        let error = false;
        (this.selectedRows || []).forEach((v) => {
          if (type === 'add' && v.status !== 'waiting') {
            error = true;
            throw '请选择 "待发货" 状态订单进行批量发货操作！';
          }
          if (type === 'edit' && v.status !== 'delivered') {
            error = true;
            throw '请选择 "已发货" 状态订单进行批量修改操作！';
          }
        });
        !error ? this.sendModelVisible = true : '';
      } catch (e) {
        this.$message.warning(e);
      }
    },
    // 批量修改/发货-确认
    sendModelConfirm() {
      this.sendModelForm.validateFields((error, value) => {
        if (error) return;
        const params = {
          ...value,
          uuid: this.selectedRowKeys,
          status: 'delivered',
        };
        this.orderEdit(params);
      });
    },
    // 查看/发货/修改-确认
    detailModelConfirm() {
      this.detailModelForm.validateFields((error, value) => {
        if (error) return error;
        const { uuid } = this.record;
        const params = {
          ...value,
          uuid: [uuid],
          status: modalTitleMap[this.detailModelType].nextStatus,
        };
        this.orderEdit(params);
      });
    },
    // 更新订单
    orderEdit(params) {
      this.confirmLoading = true;
      orderEdit(params).then(() => {
        this.confirmLoading = false;
        this.sendModelVisible = false;
        this.detailModelVisible = false;
        this.selectedRowKeys = [];
        this.getListData();
      });
    },
    // 获取基础信息
    getBaseInfo() {
      getBaseInfo({
        options: ['line', 'supplier'],
      }).then((res) => {
        this.treeData = formatTreeData('sub_line', res.line);
        const supplier = formatOptionsData('code', 'name', res.supplier);
        this.fieldsSource = (this.fieldsSource || []).map((r) => {
          if (r.name === 'supplier') {
            return {
              ...r,
              props: {
                ...(r.props || {}),
                options: supplier,
              },
            };
          }
          return r;
        });
      });
    },
    // 列表查询
    handleSubmit() {
      const formData = this.$refs['search-form'].getFieldsValue();
      // 时间
      if (formData.action_time && formData.action_time.length > 0) {
        formData.create_time_start = moment(formData.action_time[0]).valueOf();
        formData.create_time_end = moment(formData.action_time[1]).valueOf();
      } else {
        formData.create_time_start = null;
        formData.create_time_end = null;
      }
      this.searchFormData = Object.assign({}, formData);
      this.ipagination.current = 1;
      this.getListData();
    },
    // 获取列表数据
    getListData() {
      this.tableLoading = true;
      getOrderList({
        ...this.searchFormData,
        current: this.ipagination.current,
        page_size: this.ipagination.pageSize,
      }).then((res) => {
        this.tableLoading = false;
        this.ipagination = {
          current: res.current,
          pageSize: res.page_size,
          total: res.total,
          ...paginationItem,
        };
        this.tableData = (res.items || []).map((v) => ({
          ...v,
          update_time: moment(v.update_time * 1000).format('YYYY-MM-DD HH:mm:ss'),
          create_time: moment(v.create_time * 1000).format('YYYY-MM-DD HH:mm:ss'),
          status_name: v.status ? STATUS_EUNM[v.status].text : '',
          status_className: v.status ? STATUS_EUNM[v.status].className : '',
          supplier_name: v.supplier.name,
          line_name: v.line.name,
        }));
      });
    },
    // 分页改变
    handleTableChange(pagination) {
      this.ipagination.current = pagination.current;
      this.ipagination.pageSize = pagination.pageSize;
      this.getListData();
    },
    // 导出
    handleExport() {
      const formData = this.$refs['search-form'].getFieldsValue();
      // 时间
      if (formData.action_time && formData.action_time.length > 0) {
        formData.create_time_start = moment(formData.action_time[0]).valueOf();
        formData.create_time_end = moment(formData.action_time[1]).valueOf();
        delete formData.action_time;
      } else {
        formData.create_time_start = null;
        formData.create_time_end = null;
      }

      const paramsArr = [];
      Object.keys(formData).forEach((key) => {
        formData[key] ? paramsArr.push(`${key}=${formData[key]}`) : '';
      });

      // 创建a标签下载
      const a = document.createElement('a');
      let baseURL = '/';
      if (window.location.origin === 'https://tianshu.map.qq.com' || window.location.origin === 'https://tianshutest.sparta.html5.qq.com') { // 嵌套走该接口
        baseURL = `/integral_mall/`;
      }
      const href  = `${window.location.origin}${baseURL}shop_manage/order/export?${paramsArr.join('&')}`;
      console.log(href, 'href');
      a.style.display = 'none';
      a.href = href;
      document.body.appendChild(a);
      a.click();
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/less/index.less";
/deep/ .commonModal{
  .ant-form-text{
    color: #112A5A;
    line-height: 22px;
  }
  .ant-form-item{
    margin-bottom: 0;
  }
  .ant-modal-body{
    padding: 20px;
  }
  .ant-divider-horizontal{
    margin: 14px 0;
  }
  .ant-modal-footer{
    padding: 0 20px 20px 20px;
  }
  textarea.ant-input{
    margin-top: 10px;
  }
}
/deep/ .detailModal .ant-form-item-label > label{
  color: #647494;
}

</style>
